<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div class="col-md-16 px-3 py-3">
          <div class="col d-column">
            <h4 class="title" v-text="$ml.get('historicCampaign')">
              Histórico
            </h4>
            <p class="sub-title" v-text="$ml.get('campSubTitle')">
              Gerencie suas! Acompanhe todos os detalhes.
            </p>
            <p></p>
            <div class="row my-3 d-flex justify-content-end">
              <div class="col-12 pr-1 input-group">
                <multiselect
                  v-model="listFilterSelected"
                  :options="listFilter"
                  :searchable="false"
                  label="name"
                  :close-on-select="true"
                  :show-labels="false"
                  :allow-empty="false"
                  :preselect-first="true"
                  :multiple="false"
                >
                </multiselect>
              </div>
              <div class="col-12 pl-1 input-group">
                <input
                  class="form-control filterInput"
                  v-model="txtSearchProgram"
                  :placeholder="$ml.get('program')"
                  aria-label="Search"
                  style="border-right: none"
                />
                <div class="input-group-append">
                  <div class="input-group-text" style="background-color: #fff">
                    <svg width="20" height="20">
                      <image
                        xlink:href="../../../assets/icons/search_s.svg"
                        width="18"
                        height="18"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-3">
              <table>
                <thead>
                  <tr>
                    <th class="col-5" v-text="$ml.get('progCampTitle')">
                      Campanhas
                    </th>
                    <th class="col-5" v-text="$ml.get('createdTh')">
                      Criado em
                    </th>
                    <th class="col-5" v-text="$ml.get('periodTh')">Período</th>
                    <th class="col-5" v-text="$ml.get('rewardsTh')">
                      Recompensas
                    </th>
                    <th class="col-4" v-text="$ml.get('situationsTh')">
                      Situações
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="!campaignItems.length" class="loading">
                    <div v-if="loading" class="c-loader m-3"></div>
                    <h6 v-else class="col d-flex justify-content-center p-3">
                      Nenhuma campanha disponível
                    </h6>
                  </tr>
                  <tr
                    v-show="campaignItems.length"
                    v-for="(item, index) in campaignItems"
                    :key="index"
                  >
                    <td class="col-5 d-flex align-items-center">
                      <a class="a-link" v-text="item.program_name"></a>
                    </td>
                    <td
                      class="col-5 d-flex align-items-center"
                      v-text="item.initialDate"
                    ></td>
                    <td class="col-5 d-flex align-items-center">
                      {{ $ml.get("inText") }} {{ item.initialDate }} <br />
                      {{ $ml.get("until") }} {{ item.finalDate }}
                    </td>
                    <td class="col-5 d-flex align-items-center">
                      {{
                        item.doubleBounty
                          ? `${$ml.get("historicDoubleBounty")} `
                          : ""
                      }}
                      <br />
                      {{
                        item.doubleScore
                          ? `${$ml.get("historicDoubleScore")} `
                          : ""
                      }}
                    </td>
                    <td class="col-4 col-md-4 d-flex align-items-center">
                      <span
                        v-if="item.situation == 'in_progress'"
                        class="badge badge-success"
                        v-text="$ml.get('in_progress')"
                        >Em Progresso</span
                      >
                      <span
                        v-if="item.situation == 'approved'"
                        class="badge badge-success p-1"
                        v-text="$ml.get('approved')"
                        >Aprovado</span
                      >
                      <span
                        v-if="item.situation == 'canceled'"
                        class="badge badge-danger p-1"
                        v-text="$ml.get('situationCancel')"
                        >Cancelado</span
                      >
                      <span
                        v-if="item.situation == 'pending'"
                        class="badge badge-warning py-1"
                        v-text="$ml.get('pending')"
                        >Pendente</span
                      >
                      <span
                        v-if="item.situation == 'paused'"
                        v-text="$ml.get('paused')"
                        class="badge badge-warning py-1"
                        >Pausado</span
                      >
                      <span
                        v-if="item.situation == 'finished'"
                        class="badge badge-success p-1"
                        v-text="$ml.get('finished')"
                        >Finalizado</span
                      >
                      <span
                        v-if="item.situation == 'refused'"
                        class="badge badge-danger p-1"
                        v-text="$ml.get('declined')"
                        >Recusado</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-show="totalPages > 10 && !loading" class="p-3">
              <b-pagination
                v-model="pageActive"
                :total-rows="totalPages"
                :per-page="perPage"
                :prev-text="$ml.get('previous')"
                :next-text="$ml.get('next')"
                align="right"
              ></b-pagination>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>
<script>
import moment from "moment";
import ProgramService from "../../../services/program.service";
export default {
  name: "TableCampaignHistory",
  data() {
    return {
      campaignItems: [],
      listFilterSelected: [],
      txtSearchProgram: "",
      listFilter: [
        { name: `${this.$ml.get("all")}`, id: "" },
        { name: `${this.$ml.get("pending")}`, id: "pending" },
        { name: `${this.$ml.get("historicApproved")}`, id: "approved" },
        { name: `${this.$ml.get("historicCancel")}`, id: "canceled" },
        { name: `${this.$ml.get("in_progress")}`, id: "in_progress" },
        { name: `${this.$ml.get("historicPaused")}`, id: "paused" },
        { name: `${this.$ml.get("historicFinished")}`, id: "finished" },
      ],
      campaign_initial_date: null,
      loading: false,
      pageActive: 1,
      totalPages: 1,
      perPage: 3,
    };
  },
  methods: {
    changeDados() {
      let payload = "";
      this.loading = true;
      this.campaignItems = [];

      if (this.txtSearchProgram)
        payload += `&program_name=${this.txtSearchProgram}`;

      payload += `&situation=${this.listFilterSelected.id}`;
      let verify = payload.length <= 11 ? "" : payload;

      ProgramService.getCampaignHistory(this.pageActive, 10, verify).then(
        (response) => {
          this.loading = false;
          response.data.items.map((it) => {
            if (it.initialDate == it.initialDate) {
              it.initialDate = moment(it.initialDate).format("DD/MM/YYYY");
              it.finalDate = moment(it.finalDate).format("DD/MM/YYYY");
            }
            return it;
          });
          this.campaignItems = response.data.items;
          this.totalPages = response.data.total;
        },
        () => {
          this.totalPages = 0;
          this.loading = false;
        },
      );
    },
  },
  mounted() {
    this.changeDados();
  },
  watch: {
    pageActive: function () {
      this.changeDados();
    },
    txtSearchProgram: function () {
      this.changeDados();
    },
    listFilterSelected: function () {
      this.changeDados();
    },
  },
};
</script>
<style>
.sub-title {
  font-size: 1.1rem;
  color: rgba(125, 133, 142, 0.6);
}
</style>
